export default "__VITE_ASSET__DKuCrnUI__";